// extracted by mini-css-extract-plugin
export default {"page":"ItemFeedPage-m_page-ZrexunCV dim-page"};